import styled from '@emotion/styled'

export const VendorInfoFormContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',

    '.statementYear': {
      display: 'flex',
      alignItems: 'center',
      marginRight: '10px'
    }
  },
})